import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import InactiveIcon from '@mui/icons-material/RemoveSharp';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Box } from '@mui/material';

export enum ESTABLISHMENT_STATE {
    PENDIENTE = 1,
    APROBADO,
    RECHAZADO,
    INACTIVO,
    BAJA_PENDIENTE,
    MODIFICACIONES_PENDIENTES,
    DATOS_INCOMPLETOS_SRT = 8
}

// Accept iconSize in rem instead of px
const establishmentStateBadgeMap = (iconSizeRem: number) => ({
    [ESTABLISHMENT_STATE.PENDIENTE]: {
        color: '#FF9900',
        icon: <ArrowUpwardIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.APROBADO]: {
        color: '#4CAF50',
        icon: <CheckIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.RECHAZADO]: {
        color: '#F44336',
        icon: <ClearIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.INACTIVO]: {
        color: 'gray',
        icon: <InactiveIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.BAJA_PENDIENTE]: {
        color: '#FF9900',
        icon: <ArrowDownwardIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.MODIFICACIONES_PENDIENTES]: {
        color: '#175AB6',
        icon: <PriorityHighIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    },
    [ESTABLISHMENT_STATE.DATOS_INCOMPLETOS_SRT]: {
        color: '#904CE7',
        icon: <PriorityHighIcon sx={{ fontSize: `${iconSizeRem}rem` }} />
    }
});

const defaultBadge = () => <></>;

interface EstablishmentStateBadgeProps {
    state: ESTABLISHMENT_STATE;
    iconSize?: number;
    size?: number;
}

const EstablishmentStateBadge = ({
    state,
    iconSize = 16,
    size = 4
}: EstablishmentStateBadgeProps) => {
    const iconSizeRem = iconSize / 16;
    const sizeRem = size / 16;
    const badge = establishmentStateBadgeMap(iconSizeRem)[state] || defaultBadge();
    const { color, icon } = badge;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="white"
            sx={{
                backgroundColor: color,
                borderRadius: '50%',
                padding: `${sizeRem}rem`,
                width: `${(iconSize + size * 2) / 16}rem`,
                height: `${(iconSize + size * 2) / 16}rem`
            }}
        >
            {icon}
        </Box>
    );
};

export default EstablishmentStateBadge;
